import React from 'react';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';

import TransactionRow from './TransactionRow';

export default function TransactionHistory({ ledgers, refetch }) {
  return (
    <MuiTableContainer>
      <MuiTable aria-label="collapsible table">
        <MuiTableHead>
          <MuiTableRow>
            <MuiTableCell>Date</MuiTableCell>
            <MuiTableCell>Notes</MuiTableCell>
            <MuiTableCell>Source</MuiTableCell>
            <MuiTableCell align="right">Transaction</MuiTableCell>
            <MuiTableCell></MuiTableCell>
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          {ledgers.map((ledger, idx) => {
            return <TransactionRow key={idx} ledger={ledger} refetch={refetch} />;
          })}
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
}
